import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxTypedWriterModule } from 'ngx-typed-writer';
import { SharedModule } from 'src/app/shared/shared.module';
import { DelfiComponentsLibraryModule } from '@mare-common/ngx-delfi-components';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';

export interface ProductSuggestionGroup {
  problem_description: string;
  problem_name: string;
  suggestion: Array<Product>;
  // suggestion: [
  //   {
  //     sku: string;
  //     name: string;
  //     image?: string;
  //     icon?: string;
  //     suggestion: {
  //       title: string;
  //       desciption: string;
  //       solution: string;
  //     }
  //   }
  // ]
}

@Component({
  selector: 'product-related-suggestion',
  standalone: true,
  imports: [CommonModule,
    NgxTypedWriterModule,
    SharedModule,
    DelfiComponentsLibraryModule,
    TranslateModule
  ],
  templateUrl: './product-related-suggestion.component.html',
  styleUrls: ['./product-related-suggestion.component.scss'],
  animations: [
    trigger('fadeInUp', [
      state('void', style({
        opacity: 0,
        transform: 'translateY(100%)'
      })),
      
      transition('void => *', [
        animate('1s ease-out', style({
          opacity: 1,
          transform: 'translateY(0%)'
        }))
      ])
    ]),
    trigger('fadeInLeft', [
      state('void', style({
        opacity: 0,
        transform: 'translateX(100px)'
      })),
      transition('void => *', [
        animate('1s ease-out', style({
          opacity: 1,
          transform: 'translateX(0%)'
        }))
      ])
    ])
  ],
})
export class ProductRelatedSuggestionComponent {

  @Input() suggestion!: ProductSuggestionGroup;
  @Input() idx: number = 0
  @Output() completed = new EventEmitter();
  show_solution: boolean = false;
  show_products: boolean = false;
  isInView: boolean = false;
  constructor() {
    
  }

  ngOnInit() {
    // console.log('suggestion __________________-',this.suggestion)
    let timer = setTimeout(() => {
      this.isInView = true
      clearTimeout(timer);
    }, 2000)
  }

  reveal(event: any) {
    if (event) {
      this.isInView = true
    }
  }
  getDelay(index: number) {
    return `${index * 700}ms`
  }

  complete() {
    this.show_products = true;
    this.completed.emit(this.idx);
  }

}
